<div class="container p-3">
  <div class="row text-center mt-2 border-bottom">
    <div class="col-6 border-end">
      <h3 class="text-muted mt-3" *ngIf="!couponData?.products || couponData?.products == ''">0</h3>
      <h3 class="text-muted mt-3" *ngIf="couponData?.products">{{ couponData?.products.length }}</h3>
      <div class="text-muted fw-light">Products</div>
    </div>
    <div class="col-6">
      <h3 class="text-muted mt-3" *ngIf="!couponData?.details?.discount_type_id">-</h3>
      <h3 class="text-muted mt-3" *ngIf="couponData?.details?.discount_type_id">
        <span *ngIf="couponData?.details.discount_type_id == 1 && couponData?.details.dollar_discount_compare == 0">${{ couponData?.details.discount_value_lower }}</span>
        
        <span style="text-decoration: line-through; color: grey;" *ngIf="couponData?.details.discount_type_id == 1 && couponData?.details.dollar_discount_compare == 1">${{ couponData?.details.discount_value_lower }}</span>
        <span style="display: block;" *ngIf="couponData?.details.discount_type_id == 1 && couponData?.details.dollar_discount_compare == 1">${{ couponData?.details.discount_value_upper }}</span>
        
        <span *ngIf="couponData?.details.discount_type_id == 2">{{ couponData?.details.discount_value_lower }}%</span>
        
        <span *ngIf="couponData?.details.discount_type_id == 3">Buy {{ couponData?.details.discount_value_lower }} Get {{ couponData?.details.discount_value_upper }}</span>
      </h3>
      <div class="text-muted fw-light">Offer Vaule</div>
    </div>
  </div>

  <div class="row text-center mt-4" *ngIf="couponData?.details">
    <div class="col-12">

      <div class="preview-outer">
        <h4 class="text-danger" *ngIf="couponData?.details.discount_type_id == 1">Save ${{ couponData?.details.discount_value_lower }}</h4>
        <h4 class="text-danger" *ngIf="couponData?.details.discount_type_id == 2">Save {{ couponData?.details.discount_value_lower }}%</h4>
        <h4 class="text-danger" *ngIf="couponData?.details.discount_type_id == 3">Buy {{ couponData?.details.discount_value_lower }} Get {{ couponData?.details.discount_value_upper }}</h4>

        <div class="mt-1 mb-2 text-muted">{{ couponData?.details.title }}</div>

        <img class="img-preview" [src]="couponData?.details.uploadedImage">
      </div>

    </div>
  </div>

  <div class="row products-outer mt-4" *ngIf="couponData?.products?.length > 0">
    <div class="col-12">
      <h6 class="text-muted">Selected Products</h6>
      <div *ngFor="let product of couponData.products; let i = index;">
        <span class="products text-muted">{{ i+1 }}. {{ product.item_name }} ({{ product.upc }})</span>
      </div>
    </div>
  </div>

  <div class="row products-outer mt-4" *ngIf="couponData?.details?.categories?.length > 0">
    <div class="col-12">
      <h6 class="text-muted">Categories</h6>
      <div *ngFor="let category of couponData.details.categories; let i = index;">
        <span class="products text-muted">{{ i+1 }}. {{ category.category_name }}</span>
      </div>
    </div>
  </div>

  <div class="row products-outer mt-4" *ngIf="couponData?.details?.manufacturer">
    <div class="col-12">
      <h6 class="text-muted">Manufacturer</h6>
      <div>
        <span class="products text-muted">{{ couponData?.details?.manufacturer.mfg_name }}</span>
      </div>
    </div>
  </div>

  <div class="row products-outer mt-4" *ngIf="couponData?.details?.brand">
    <div class="col-12">
      <h6 class="text-muted">Brand</h6>
      <div>
        <span class="products text-muted">{{ couponData?.details?.brand.brand_name }}</span>
      </div>
    </div>
  </div>
</div>
